// SynapseAI deployment
export const user_pool_id = "af-south-1_qPuwCxFmu"
export const client_id = "2v4os5rm34263pbu1ktp8354de"

//Microsoft Entra ID Configuration
export const entra_id_client_id = 'aea2a581-3f0e-49ba-a678-781c80570d39';
export const entra_id_tenant_id = 'e707f645-7111-48d6-8c2f-ae3c1756e1a7';

export const IS_PRODUCTION = true;

// Server ENDPOINT Configuration
export const HOSTING_ENDPOINT = 'https://audidox.com';
// PRODUCTION
export const WS_URL = 'wss://audidox.medassist.mu';
export const API_URL = "https://audidox.medassist.mu/api"
export const HOSTING_URL = "https://audidox.medassist.mu";

// TEST
export const TEST_WS_URL = 'ws://localhost:4000';
export const TEST_API_URL = 'http://localhost:4000/api';